import { Heading as BaseHeading } from '@gohighlevel/ghl-text-editor'
import { mergeAttributes } from '@tiptap/vue-3'

const DEFAULT_HEADING_FONT_SIZES: Record<number, string> = {
  1: '32px',
  2: '24px',
  3: '18px',
  4: '16px',
  5: '14px',
}

export const ExtendedHeading = BaseHeading.extend({
  name: 'heading',

  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        rendered: true,
        parseHTML: element => element.getAttribute('style') || null,
        renderHTML: attributes => {
          const defaultSize = DEFAULT_HEADING_FONT_SIZES[attributes.level]
          const lineHeight = attributes.lineHeight || 1.5
          return {
            style: `font-size: ${defaultSize}; line-height: ${lineHeight}`,
          }
        },
      },
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    const hasLevel = this.options.levels.includes(node.attrs.level)
    const level = hasLevel ? node.attrs.level : this.options.levels[0]

    return [
      `h${level}`,
      mergeAttributes(this.options.HTMLAttributes, {
        ...HTMLAttributes,
        // 🧼 Clean duplicate styles (especially if mergeAttributes merges styles again)
        style: deduplicateStyles(HTMLAttributes.style),
      }),
      0,
    ]
  },
})

// ✅ Helper to remove duplicate style declarations
function deduplicateStyles(styleString?: string): string {
  if (!styleString) return ''
  const styleMap = new Map()

  styleString.split(';').forEach(pair => {
    const [key, value] = pair.split(':').map(s => s?.trim())
    if (key && value) {
      styleMap.set(key, value) // Last one wins (in case of duplicate keys)
    }
  })

  return Array.from(styleMap.entries())
    .map(([key, value]) => `${key}: ${value}`)
    .join('; ')
}
